import '~/index.css'
import { render } from 'solid-js/web'
import { App } from './App'

const root = document.getElementById('root')
if (!root) {
  throw new Error('Элемент #root не найден в index.html')
}

render(() => <App />, root)
